import api from "./api";

const moduleName = "auth";

export default {
  signUp(data) {
    return api().post(`${moduleName}/sign-up`, data);
  }
};
